import React from 'react';

import { useTranslation } from 'react-i18next';
import TranscriptIcon from '../../images/transcript.inline.svg';
import { clsx, replaceNewLinesWithBr } from '../../utils/utils';
import ModalOverlay from './ModalOverlay';
import * as styles from './VideoTranscriptionModal.module.scss';

export interface VideoTranscriptionModalProps {
  title?: string;
  subtitle?: string;
  text: string;
  onClose: () => void;
  isOpen: boolean;
  className?: string;
}

const VideoTranscriptionModal = ({
  title,
  subtitle,
  text,
  onClose,
  isOpen,
  className,
}: VideoTranscriptionModalProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <ModalOverlay
      className={clsx(styles.modal, className)}
      onClose={onClose}
      open={isOpen}
      title={
        <div className={styles.modalTitleContainer}>
          <span className={styles.videoTranscriptionSupertitle}>
            <TranscriptIcon className={styles.modalIcon} />{' '}
            {t('hero.video_transcription_modal_supertitle', 'Transcrição de vídeo')}
          </span>
          {title && <h2 className={styles.modalTitle}>{title}</h2>}
          {subtitle && <p className={styles.modalVideoSubtitle}>{subtitle}</p>}
        </div>
      }
    >
      <div className={styles.videoTranscriptionContainer}>
        <p className={styles.videoTranscription}>{replaceNewLinesWithBr(text)}</p>
      </div>
    </ModalOverlay>
  );
};

export default VideoTranscriptionModal;
